import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTimesCircle,
  faInfoCircle,
  faCheckCircle,
  faExclamationCircle
} from "@fortawesome/free-solid-svg-icons";

type AlertType = "success" | "info" | "warning" | "danger";

type AlertMessageProps = {
  children?: React.ReactNode | null;
  visible?: boolean;
  alertType?: AlertType;
  className?: string;
};

export function AlertMessage(props: AlertMessageProps) {
  const { children, alertType = "info", className = "", visible = false } = props;

  if (visible === false) {
    return null;
  }

  const alertTypes = {
    success: {
      icon: faCheckCircle,
      className: "alert alert-success"
    },
    info: {
      icon: faInfoCircle,
      className: "alert alert-info"
    },
    warning: {
      icon: faExclamationCircle,
      className: "alert alert-warning"
    },
    danger: {
      icon: faTimesCircle,
      className: "alert alert-danger"
    }
  };
  const alertClass = alertTypes[alertType]?.className || alertTypes["info"].className;
  const alertIcon = alertTypes[alertType]?.icon || alertTypes["info"].icon;

  return (
    <div className={`${className} ${alertClass}`} role="alert">
      <FontAwesomeIcon icon={alertIcon} /> {children}
    </div>
  );
}

export default AlertMessage;
